import axios from "axios";

import { fetchCookie } from "@utils/cookies";
import { validateCurrentToken, clearAuthData } from "@utils/tokenUtils";

const customFetch = axios.create({
  baseURL: process.env["REACT_APP_API_BASE_URL"],
});

customFetch.interceptors.request.use((config: any) => {
  if (!validateCurrentToken()) {
    return Promise.reject(new Error("Token expired"));
  }

  let _token = fetchCookie("1Q_SPA");
  if (_token) {
    config.headers.common["Authorization"] = `Bearer ${_token}`;
  }

  const source = axios.CancelToken.source();
  config.cancelToken = source.token;
  config.cancel = () => {
    source.cancel("Request canceled by user");
  };

  return config;
});

customFetch.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      clearAuthData();
      const next = `${window.location.pathname}${window.location.search}`;
      if (
        next &&
        next !== "/" &&
        !next.startsWith("/sign-in") &&
        !next.startsWith("/get-started")
      ) {
        localStorage.setItem("postLoginRedirect", next);
      }
      window.location.href = "/?auth=login";
    }

    return Promise.reject(error);
  }
);

export default customFetch;
